module.exports = __webpack_public_path__ + "static/media/neighbourhood-03-twinsails.dbaba472.jpg";